export default __webpack_public_path__ + "9b9c8709b2651c6abca4a574f5ed1e35.png";